import { Injectable } from '@angular/core';
import {DataUtils} from 'ng-jhipster';
import {Observable} from 'rxjs';
import {Http, Response, Headers} from '@angular/http';
import {UserBlob} from './user-blob.model';
import {UploadProgressService} from './upload-progress.service';

@Injectable()
export class UploadService {
    MAX_FILE_SIZE = 5242880;

    private acceptedContentTypesUrl = 'api/storage/accepted-content-types';
    private blobsUrl = 'api/storage/blobs';
    private tokenForBlobUrl = 'api/storage/token-for-blob';

    private acceptedContentTypesCache: Array<String>;

    constructor(private http: Http,
                private dataUtils: DataUtils,
                private uploadProgressService: UploadProgressService) { }

    uploadBlob($file): Observable<UserBlob> {
        return this.performUpload($file, this.blobsUrl).map((res: Response) => res.json() as UserBlob);
    }

    private performUpload($file, url): Observable<Response> {
        return this.isAcceptableUploadContentType($file.type).flatMap(acceptable => {
            if (acceptable) {
                let headers = new Headers();
                headers.append('X-Requested-With', 'XMLHttpRequest');
                let formData: FormData = new FormData();
                formData.append('file', $file);
                return this.http.post(url, formData, { headers: headers });
            } else {
                return Observable.throw(`type ${$file.type} not acceptable.`);
            }
        });
    }

    isAcceptableUploadContentType(type: String): Observable<boolean> {
        return this.getAcceptedUploadContentTypes().map(
            (arr: Array<String>) => {
                return !!arr.find(ct => ct === type);
            }
        );
    }

    getAcceptedUploadContentTypes(): Observable<Array<String>> {
        if (this.acceptedContentTypesCache) {
            return Observable.of(this.acceptedContentTypesCache);
        }
        return this.http.get(this.acceptedContentTypesUrl)
            .map((res: any) => {
                this.acceptedContentTypesCache = res.json() as Array<String>;
                return this.acceptedContentTypesCache;
            });
    }

    downloadBlob(id: string): void {
        // Keep window reference to prevent popup to be blocked
        let w = window.open('', '_parent');
        this.tokenForBlob(id).subscribe(token => {
            // it is safe to change location here
            w.location.href = `${this.blobsUrl}/${id}?token=${token}`;
        });
    }

    public tokenForBlob(id: string): Observable<string> {
        return this.http.get(`${this.tokenForBlobUrl}/${id}`)
            .map((res: Response) => res.text());
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/upload/upload.service.ts